// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3wPVn","validationTips":"StatementDescriptor_validationTips__2eLW_"};